export default class Invalid {
	primitives: object;
	constructor( primitives ) {
		this.primitives = primitives;
	}
}